'use client';

import React from 'react';
import styled from '@benzinga/themetron';
import { capitalize } from '@benzinga/utils';

export interface ErrorsBoxProps {
  error?: string | null;
  errors?: string[] | string | null;
  type?: 'box' | 'text';
  includeKeys?: boolean;
}

export const ErrorsBox: React.FC<ErrorsBoxProps> = ({ error, errors, includeKeys = false, type }) => {
  if (!Array.isArray(errors) && typeof errors !== 'object') {
    errors = errors ? [errors] : null;
  }
  if (errors)
    return (
      <ErrorsBoxWrapper className="error-box" style={{ marginTop: 6 }}>
        {Object.keys(errors).map((key, i) => {
          const error = errors ? errors[key] : null;
          console.error(error, key);
          if (Array.isArray(error)) {
            return error.map((err, n) => {
              return (
                <div key={`${key}-${i}-${n}`} style={{ color: 'red', marginTop: 4 }}>
                  {includeKeys ? `${key}: ${err}` : err}
                </div>
              );
            });
          } else if (typeof error === 'string') {
            return (
              <div key={`${key}-${i}`} style={{ color: 'red', marginTop: 4 }}>
                {error}
              </div>
            );
          }
          return null;
        })}
      </ErrorsBoxWrapper>
    );
  if (error) return <ErrorsBoxWrapper className={`error-box ${type}`}>{capitalize(error)}</ErrorsBoxWrapper>;
  else return <div />;
};

export default ErrorsBox;

export const ErrorsBoxWrapper = styled.div`
  &.error-box {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colorPalette.red600};
    font-size: ${({ theme }) => theme.fontSize.sm};

    &.box {
      padding: 0.25rem 0.25rem;
      background-color: ${({ theme }) => theme.colorPalette.red100};
      border: 1px solid ${({ theme }) => theme.colorPalette.red600};
      border-radius: ${({ theme }) => theme.borderRadius.default};
    }
  }
`;
